module.exports = __webpack_public_path__ + "static/img/info-1.03b91ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sqdz_infor/info-1.png
// module id = 250
// module chunks = 6